import "./Footer.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer className="site-footer" id="contacts">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <Link className="site-footer__logo" to="/" aria-label="Active Generation — головна">
            <span>ACTIVE</span>
            <span>GENERATION</span>
          </Link>
          <p>{t("footer.description")}</p>
          <div className="site-footer__contacts">
            <a href="mailto:active.generation.official@gmail.com">active.generation.official@gmail.com</a>
            <a href="https://maps.app.goo.gl/SMANhiNuD16tr93G9" target="_blank" rel="noreferrer">{t("cityMykolaiv")}</a>
          </div>
        </div>

        <nav className="site-footer__column" aria-label={t("footer.navigationTitle")}>
          <h3>{t("footer.navigationTitle")}</h3>
          <a href="/#about">{t("navigation.about")}</a>
          <a href="/#philosophy">{t("navigation.philosophy")}</a>
          <a href="/#events">{t("navigation.events")}</a>
        </nav>

        <nav className="site-footer__column" aria-label={t("footer.pagesTitle")}>
          <h3>{t("footer.pagesTitle")}</h3>
          <Link to="/projects">{t("navigation.projects")}</Link>
          <Link to="/reports">{t("navigation.reports")}</Link>
          <Link to="/team">{t("navigation.team")}</Link>
          <Link to="/tips">{t("navigation.tips")}</Link>
        </nav>

        <div className="site-footer__column site-footer__socials">
          <h3>{t("footer.socialTitle")}</h3>
          <a href="https://www.instagram.com/active_generation_" target="_blank" rel="noreferrer">Instagram</a>
          <a href="https://t.me/active_generation" target="_blank" rel="noreferrer">Telegram</a>
          <a href="https://www.youtube.com/@ActiveGeneration" target="_blank" rel="noreferrer">YouTube</a>
          <a href="https://www.facebook.com/profile.php?id=100093272753934" target="_blank" rel="noreferrer">Facebook</a>
          <a href="https://www.tiktok.com/@active_generation_" target="_blank" rel="noreferrer">TikTok</a>
          <a href="https://linktr.ee/active_generation" target="_blank" rel="noreferrer">Linktree</a>
        </div>
      </div>

      <div className="site-footer__bottom">
        <span>© {currentYear} Active Generation</span>
        <span>ACTIVE GENERATION</span>
      </div>
    </footer>
  );
}

export default Footer;
